import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=0c965fec&"
import script from "./custom.vue?vue&type=script&lang=js&"
export * from "./custom.vue?vue&type=script&lang=js&"
import style0 from "./custom.vue?vue&type=style&index=0&id=0c965fec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports